import  { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { SingleValue } from "react-select";
import { all_routes } from "../router/all_routes";
import TooltipOption from "../../core/common/tooltipOption";
import { _get } from "../Utils/Helper";
import SyllabusItem, { SyllabusItemProps } from "./SyllabusItem";
import SyllabusModal from "../../core/modals/SyllabusModal";
import CommonSelect, { Option } from "../../core/common/commonSelect";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/reducers";

const terms = ['First Term', 'Second Term', 'Third Term'];

const Syllabus = () => {
  
  const _form = {
    query_type:"create",
    status:"",
    subject:"",
    class_name:"",
    class_code:"",
    term:"",
  }
  const [form, setForm] = useState(_form)
  const [syllabus, setSyllabus] = useState<SyllabusItemProps[]>([]);
  const [selected, setSelected]  = useState<SyllabusItemProps>();
  const {subjects, classes} = useSelector((state:RootState)=>state.auth)
  // const type_arr = ['profile','home','messages','settings'];
  // const status_arr = ['Pending','Completed','Inprogress','Deleted']
  // const colors =  ['text-info','text-danger','text-warning','text-success']

  const getSyllabus = useCallback(() =>{
    _get(
      `syllabus?query_type=select&class_code=${form.class_code}&subject=${form.subject}&term=${form.term}`,
      (res) => {
        if (res.success && res.data.length) {
          console.log(res);
          setSyllabus(res.data);
        }
      },
      (err) => {
        console.error(err);
      }
    );
  },[form.class_code])

useEffect(() =>{
  getSyllabus();
},[getSyllabus]);

  const routes = all_routes;
  const subjectsOptions = subjects.map((item:any)=>({value:item.subject, label:item.subject}))
  const classesOptions = classes.map((item:any)=>({value:item.class_code, label:item.class_name}))
  const termsOptions = terms.map((item:any)=>({value:item, label:item}))
  return (
    <>
      <div className="page-wrapper notes-page-wrapper">
        {/* {JSON.stringify({classes})} */}

        <div className="content pb-4">
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3 pb-3 border-bottom position-relative">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Syllabus</h3>
              {/* <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">Academic</li>
                  <li className="breadcrumb-item active" aria-current="page">
                  Syllabus
                  </li>
                </ol>
              </nav> */}
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <TooltipOption />
              <div className="mb-2">
                <Link
                  to="#"
                  className="btn btn-primary d-flex align-items-center"
                  data-bs-toggle="modal"
                  data-bs-target="#note-units"
                >
                  <i className="ti ti-square-rounded-plus me-2" />
                  Add Syllabus
                </Link>
              </div>
            </div>
            <Link
              id="toggle_btn2"
              className="notes-tog position-absolute start-0 avatar avatar-sm rounded-circle bg-primary text-white"
              to="#"
            >
              <i className="fas fa-chevron-left" />
            </Link>
          </div>
          <div className="row">
            <div className="col-xl-12 col-md-12 sidebars-right theiaStickySidebar section-bulk-widget">
              <div className="stickybar">
                <div className="border rounded-3 mt-4 bg-white p-3">
                  <div className="mb-3 pb-3 border-bottom d-flex align-items-center">
                    <h4 className="">
                      Filter  <i className="ti ti-filter me-2" />
                    </h4>
                    {/* <div className="me-3">
                      <label>Status</label>
                    <CommonSelect
                    placeholder="Status"
                      options={status_arr.map((status)=>({label:status, value:status}))}
                      className="select"
                      defaultValue={{
                        value: form.status,
                        label: form.status,
                      }}
                      handleChange={((item: SingleValue<Option>) => {
                        setForm((p)=>({...p, status: item?.value||""}));
                      })}
                    />
                  </div> */}
                  
                  <div className="me-3">
                    <label><b>Class</b></label>
                    <CommonSelect
                    placeholder="Class"
                      options={classesOptions}
                      className="select"
                      defaultValue={{
                        value: form.class_name,
                        label: form.class_name,
                      }}
                      handleChange={((item: SingleValue<Option>) => {
                        setForm((p)=>({...p, class_name: item?.value||"", class_code: item?.value||""}));
                      })}
                    />
                  </div>
                  
                  <div className="me-3">
                    <label><b>Term</b></label>
                    <CommonSelect
                    placeholder="Term"
                      options={termsOptions}
                      className="select"
                      defaultValue={{
                        value: form.term,
                        label: form.term,
                      }}
                      handleChange={((item: SingleValue<Option>) => {
                        setForm((p)=>({...p, term: item?.value||""}));
                      })}
                    />
                  </div>
                  <div className="me-3">
                    <label><b>Subject</b></label>
                    <CommonSelect
                    placeholder="Subject"
                      options={subjectsOptions}
                      className="select"
                      defaultValue={{
                        value: form.subject,
                        label: form.subject,
                      }}
                      handleChange={((item: SingleValue<Option>) => {
                        setForm((p)=>({...p, subject: item?.value||""}));
                      })}
                    />
                  </div>
                  <div className="me-3 mt-3">
                  <Link to="#" onClick={()=>{getSyllabus()}} className="btn btn-light">
                    Apply
                  </Link>
                </div>
                </div>
                 
                  {/* <div className="mt-3">
                    <div className="border-bottom px-2 pb-3 mb-3">
                      <h5 className="mb-2">Status</h5>
                      <div className="d-flex flex-column mt-2">
                        <Link to="#" className="text-info mb-2">
                          <span className="text-info me-2">
                            <i className="fas fa-square square-rotate fs-10" />
                          </span>
                          Pending
                        </Link>
                        <Link to="#" className="text-danger mb-2">
                          <span className="text-danger me-2">
                            <i className="fas fa-square square-rotate fs-10" />
                          </span>
                          Onhold
                        </Link>
                        <Link to="#" className="text-warning mb-2">
                          <span className="text-warning me-2">
                            <i className="fas fa-square square-rotate fs-10" />
                          </span>
                          Inprogress
                        </Link>
                        <Link to="#" className="text-success">
                          <span className="text-success me-2">
                            <i className="fas fa-square square-rotate fs-10" />
                          </span>
                          Completed
                        </Link>
                      </div>
                    </div>
                     <div className="px-2">
                      <h5 className="mb-2">Priority</h5>
                      <div className="d-flex flex-column mt-2">
                        <Link to="#" className="text-warning mb-2">
                          <span className="text-warning me-2">
                            <i className="fas fa-square square-rotate fs-10" />
                          </span>
                          Medium
                        </Link>
                        <Link to="#" className="text-success mb-2">
                          <span className="text-success me-2">
                            <i className="fas fa-square square-rotate fs-10" />
                          </span>
                          High
                        </Link>
                        <Link to="#" className="text-danger">
                          <span className="text-danger me-2">
                            <i className="fas fa-square square-rotate fs-10" />
                          </span>
                          Low
                        </Link>
                      </div>
                    </div> *
                  </div> */}
                </div>
              </div>
            </div>
          
            <div className="col-xl-9 budget-role-notes">
              <div className="bg-white rounded-3 d-flex align-items-center justify-content-between  my-4 p-3 pb-0">
               
                {/* <div className="form-sort mb-3"> */}
                  {/* <i className="ti ti-filter feather-filter info-img ms-1" /> */}
                  {/* <Select
                    className="select"
                    classNamePrefix="react-select"
                    options={lastModified}
                    placeholder="Sort by Date"
                  /> */}
                {/* </div> */}
              </div>
              <div className="tab-content" id="v-pills-tabContent">
                <div
                  className="tab-pane fade active show"
                  id="v-pills-profile"
                  role="tabpanel"
                  aria-labelledby="v-pills-profile-tab"
                >
                  <div className="row">
                    <div className="col-lg-12">
                    {syllabus.length? syllabus.filter((item:any)=>item.status ==='Pending').map((todo)=> <SyllabusItem setSelected={setSelected} {...todo}/>):null}
                
                      {/* <div
                        className="accordion todo-accordion"
                        id="accordionExample"
                      >
                        <div className="accordion-item">
                          <div className="accordion-header" id="headingOne">
                            <div
                              className="accordion-button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseOne"
                              aria-controls="collapseOne"
                            >
                              <div className="d-flex align-items-center justify-content-between w-100 mb-3">
                                <div className="d-flex align-items-center">
                                  <span>
                                    <i className="ti ti-calendar-due me-2" />
                                  </span>
                                  <h5 className="fw-semibold">Today</h5>
                                  <span className="avatar avatar-xs bg-primary rounded-circle p-1 ms-2">
                                    1
                                  </span>
                                </div>
                                <div>
                                  <Link to="#">
                                    <span>
                                      <i className="fas fa-chevron-down" />
                                    </span>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            id="collapseOne"
                            className="accordion-collapse collapse show"
                            aria-labelledby="headingOne"
                            data-bs-parent="#accordionExample"
                          >
                            <div className="accordion-body">
                            {syllabus.length? syllabus.filter((item:any)=>item.status ==='Completed').map((todo)=> <SyllabusItem {...todo}/>):null}
                
                            </div>
                          </div>
                        </div>
                      </div> */}
                      {/* <div
                        className="accordion todo-accordion"
                        id="accordionExample2"
                      >
                        <div className="accordion-item">
                          <div className="accordion-header" id="headingTwo">
                            <div
                              className="accordion-button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseTwo"
                              aria-controls="collapseTwo"
                            >
                              <div className="d-flex align-items-center justify-content-between w-100 mb-3">
                                <div className="d-flex align-items-center">
                                  <span>
                                    <i className="ti ti-calendar-due me-2" />
                                  </span>
                                  <h5 className="fw-semibold">Yesterday</h5>
                                </div>
                                <div>
                                  <Link to="#">
                                    <span>
                                      <i className="fas fa-chevron-down" />
                                    </span>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            id="collapseTwo"
                            className="accordion-collapse collapse show"
                            aria-labelledby="headingTwo"
                            data-bs-parent="#accordionExample2"
                          >
                          {syllabus.length? <SyllabusItem {...syllabus[0]}/>:null}
                          </div>
                        </div>
                      </div> */}
                      {/* <div
                        className="accordion todo-accordion"
                        id="accordionExample4"
                      >
                        <div className="accordion-item">
                          <div className="accordion-header" id="headingFour">
                            <div
                              className="accordion-button"
                              data-bs-toggle="collapse"
                              data-bs-target="#collapseFour"
                              aria-controls="collapseFour"
                            >
                              <div className="d-flex align-items-center justify-content-between w-100 mb-3">
                                <div className="d-flex align-items-center">
                                  <span>
                                    <i className="ti ti-calendar-due me-2" />
                                  </span>
                                  <h5 className="fw-semibold">25/07/2023</h5>
                                </div>
                                <div>
                                  <Link to="#">
                                    <span>
                                      <i className="fas fa-chevron-down" />
                                    </span>
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            id="collapseFour"
                            className="accordion-collapse collapse show"
                            aria-labelledby="headingFour"
                            data-bs-parent="#accordionExample4"
                          >
                            <div className="accordion-body">
                                {syllabus.length? syllabus.filter((item:any)=>item.status ==='Pending').map((todo)=> <SyllabusItem {...todo}/>):null}
                            </div>
                          </div>
                        </div>
                      </div> */}
                    </div>
                  </div>
                </div>
                <div
                  className="tab-pane fade "
                  id="v-pills-home"
                  role="tabpanel"
                  aria-labelledby="v-pills-home-tab"
                >
                  <div className="d-block">
                    {syllabus.length? syllabus.filter((item:any)=>item.status ==='Completed').map((todo)=> <SyllabusItem setSelected={setSelected} {...todo}/>):null}
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="v-pills-messages"
                  role="tabpanel"
                  aria-labelledby="v-pills-messages-tab"
                >
                  <div className="d-block">
                  {syllabus.length? syllabus.filter((item:any)=>item.status ==='Inprogress').map((todo)=> <SyllabusItem setSelected={setSelected} {...todo}/>):null}
                  </div>
                </div>
                <div
                  className="tab-pane fade"
                  id="v-pills-settings"
                  role="tabpanel"
                  aria-labelledby="v-pills-settings-tab"
                >
                  <div className="d-block">
                  {syllabus.length? syllabus.filter((item:any)=>item.status ==='Deleted').map((todo)=> <SyllabusItem setSelected={setSelected} {...todo}/>):null}
                   
                  </div>
                </div>
              </div>
              {/* <div className="row custom-pagination">
                <div className="col-md-12">
                  <div className="paginations d-flex justify-content-end">
                    <span>
                      <i className="fas fa-chevron-left" />
                    </span>
                    <ul className="d-flex align-items-center page-wrap">
                      <li>
                        <Link to="#" className="active">
                          1
                        </Link>
                      </li>
                      <li>
                        <Link to="#">2</Link>
                      </li>
                      <li>
                        <Link to="#">3</Link>
                      </li>
                      <li>
                        <Link to="#">4</Link>
                      </li>
                    </ul>
                    <span>
                      <i className="fas fa-chevron-right" />
                    </span>
                  </div>
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <SyllabusModal selected={selected}/>
    </>
  );
};

export default Syllabus;
